import createReactComponent from '../createReactComponent';
export default createReactComponent('math', 'IconMath', [
  ['path', { d: 'M19 5h-7l-4 14l-3 -6h-2', key: 'svg-0' }],
  ['path', { d: 'M14 13l6 6', key: 'svg-1' }],
  ['path', { d: 'M14 19l6 -6', key: 'svg-2' }],
]);
